export default "__VITE_ASSET__b021b59d__"